var _path, _rect, _g, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2335 26.4388C58.4452 27.5687 58.5115 29.4671 57.3816 30.6788L35.5961 54.041C34.2402 55.4951 31.9622 55.5747 30.5081 54.2187L22.4562 46.7102C21.2444 45.5802 21.1781 43.6819 22.3081 42.4701C23.4381 41.2584 25.3364 41.1921 26.5482 42.3221L32.8448 48.1938L52.9934 26.5868C54.1234 25.3751 56.0217 25.3088 57.2335 26.4388Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4121_11073",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 32,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4121_11073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.38281 30.4609C-5.38281 12.7878 8.94407 -1.53906 26.6172 -1.53906H58.0018C75.6749 -1.53906 90.0018 12.7878 90.0018 30.4609V57.9994C90.0018 75.6725 75.6749 89.9994 58.0018 89.9994H26.6172C8.9441 89.9994 -5.38281 75.6725 -5.38281 57.9994V30.4609Z",
    fill: "url(#paint0_linear_4121_11073)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8399 25.9007C27.9171 24.8078 29.6717 24.7994 30.759 25.882L54.7912 49.8098C55.8785 50.8924 55.8868 52.656 54.8097 53.7489C53.7326 54.8418 51.978 54.8501 50.8906 53.7675L26.8585 29.8398C25.7711 28.7571 25.7628 26.9936 26.8399 25.9007Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8445 25.822C55.9233 26.9132 55.9178 28.6768 54.8322 29.7611L30.7247 53.8403C29.639 54.9247 27.8844 54.9192 26.8055 53.828C25.7267 52.7368 25.7322 50.9732 26.8178 49.8889L50.9253 25.8097C52.011 24.7253 53.7656 24.7308 54.8445 25.822Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4121_11073",
    x1: -3.09358,
    y1: 12.1917,
    x2: 85.2654,
    y2: 103.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD180"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.904a3eabb448c6e98217ba23d9c489d8.svg";
export { ForwardRef as ReactComponent };